import * as React from 'react';

import { ComboBox, useComboBoxOptions } from '@rematter/ui-web';

import { useFacilitiesQuery } from '~/modules/transportation/hooks/queries/useFacilitiesQuery';

interface FacilitySelectFieldProps {
  label: string;
  value: string | null;
  onChange: (facilityId: string | null, facilityName: string | null) => void;
  isRequired?: boolean;
  isDisabled?: boolean;
}

export const FacilitySelectField = ({
  label,
  value,
  onChange,
  isRequired,
  isDisabled,
}: FacilitySelectFieldProps) => {
  const { data } = useFacilitiesQuery({ limit: 100 });

  const facilityOptions = React.useMemo(
    () =>
      (data?.facilities ?? []).map((facility) => ({
        id: facility.id,
        label: facility.facilityName,
      })),
    [data?.facilities],
  );

  const { query, onChangeQuery, filteredOptions } = useComboBoxOptions({
    value: value || '',
    options: facilityOptions,
    disabled: isDisabled,
  });

  const handleSelectionChange = (values: string[]) => {
    const facility = data?.facilities.find((f) => f.id === values[0]);
    onChange(facility?.id ?? null, facility?.facilityName ?? null);
  };

  return (
    <ComboBox
      label={label}
      value={value ? [value] : []}
      isRequired={isRequired}
      isDisabled={isDisabled}
      onChange={handleSelectionChange}
      query={query}
      onChangeQuery={onChangeQuery}
      options={filteredOptions}
      className="@FacilitySelectField"
      getSelection={(ids) =>
        ids.map((id) => {
          const facility = data?.facilities.find((f) => f.id === id);
          return { label: facility?.facilityName || '' };
        })
      }
    />
  );
};
